// extracted by mini-css-extract-plugin
export default {"imageWrapper":"lK-z","twoColumnImage":"mK-z"};